import { graphql } from 'react-relay';
import {} from '../queries/User.query';
import { genericMutation, useGenericMutation } from '../utils';
import type { User_CreateUser_Mutation } from './__generated__/User_CreateUser_Mutation.graphql';
import type { User_DeleteUser_Mutation } from './__generated__/User_DeleteUser_Mutation.graphql';
import type { User_SendPasswordResetEmail_Mutation } from './__generated__/User_SendPasswordResetEmail_Mutation.graphql';
import type { User_UpdateUser_Mutation } from './__generated__/User_UpdateUser_Mutation.graphql';

const UpdateUserMutation = graphql`
  mutation User_UpdateUser_Mutation($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        ...User_Management_Fragment @relay(mask: false)
      }
    }
  }
`;

export const updateUserMutation = genericMutation<User_UpdateUser_Mutation>({
  mutation: UpdateUserMutation,
});

export const useUpdateUserMutation = useGenericMutation<User_UpdateUser_Mutation>(updateUserMutation);

const CreateUserMutation = graphql`
  mutation User_CreateUser_Mutation($input: CreateUserInput!, $connections: [ID!]!) {
    createUser(input: $input) {
      user @prependNode(connections: $connections, edgeTypeName: "User") {
        id
        email
        username
        ...User_Management_Fragment @relay(mask: false)
      }
    }
  }
`;

export type {
  User_CreateUser_Mutation,
  User_CreateUser_Mutation$data,
} from './__generated__/User_CreateUser_Mutation.graphql';

export const createUserMutation = genericMutation<User_CreateUser_Mutation>({
  mutation: CreateUserMutation,
});

const DeleteUserMutation = graphql`
  mutation User_DeleteUser_Mutation($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      deletedId @deleteRecord
    }
  }
`;

export type {
  User_DeleteUser_Mutation,
  User_DeleteUser_Mutation$data,
} from './__generated__/User_DeleteUser_Mutation.graphql';

export const deleteUserMutation = genericMutation<User_DeleteUser_Mutation>({
  mutation: DeleteUserMutation,
});

export const useDeleteUserMutation = useGenericMutation<User_DeleteUser_Mutation>(deleteUserMutation);

const SendPasswordResetEmailMutation = graphql`
  mutation User_SendPasswordResetEmail_Mutation($input: SendPasswordResetEmailInput!) {
    sendPasswordResetEmail(input: $input) {
      success
    }
  }
`;

export const sendPasswordResetEmailMutation = genericMutation<User_SendPasswordResetEmail_Mutation>({
  mutation: SendPasswordResetEmailMutation,
});
